@if (measurement(); as m) {
  <div>
    <p-card id="onboarding-measurement-info-card">
        <ng-template #title>{{ m.name }}</ng-template>
        <ng-template #subtitle>{{ cardSubtitle() }}</ng-template>
        <!-- content -->
        <div class="card-list-item">
          <div class="card-list-item-icon"><i class="fa-solid fa-clock"></i></div>
          <div class="item-text">
            <div class="item-title">{{ m.createdAt | date:'dd/MM/yyyy HH:mm:ss' }}</div>
            <div class="item-line">{{ "measurement.created" | translate }}</div>
          </div>
        </div>
        <div class="card-list-item">
          <div class="card-list-item-icon"><i class="fa-solid fa-clock-rotate-left"></i></div>
          <div class="item-text">
            <div class="item-title">{{ m.updatedAt | date:'dd/MM/yyyy HH:mm:ss' }}</div>
            <div class="item-line">{{ "measurement.updated" | translate }}</div>
          </div>
        </div>

        <p-divider></p-divider>

        <div class="card-list-item">
          <div class="card-list-item-icon"><i class="fa-solid fa-align-left"></i></div>
          <div class="item-text">
            <div class="item-title">{{ m.description ? m.description : '-' }}</div>
            <div class="item-line">{{ "measurement.card.description" | translate }}</div>
          </div>
        </div>
        <div class="card-list-item">
          <div class="card-list-item-icon"><i class="fa-solid fa-mobile"></i></div>
          <div class="item-text">
            <div class="item-title">{{ device()?.name }}</div>
            <div class="item-line">{{ "measurement.card.device" | translate }}</div>
          </div>
        </div>
        @if (concrete()) {
          <div class="card-list-item">
            <div class="card-list-item-icon"><i class="fa-solid fa-flask-vial"></i></div>
            <div class="item-text">
              <div class="item-title">{{ concrete()?.name }}</div>
              <div class="item-line">{{ "measurement.card.concrete" | translate }}</div>
            </div>
          </div>
        }

        <ng-template #footer>
          <ng-content select="[cardFooter]"></ng-content>
        </ng-template>
    </p-card>
  </div>
}
